export default __webpack_public_path__ + "static/media/illustration-4.64f821d8.webp";